import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'Where are you located?',
  answer: 'We are conveniently located at 24786 Crestview in Farmington Hills, MI, easily accessible from Novi, Commerce, Livonia, and surrounding areas.'
}, {
  question: 'Do you offer classes for beginners?',
  answer: 'Yes! The majority of our new students start with no prior martial arts experience. We have dedicated beginner classes for all age groups.'
}, {
  question: 'What age groups do you teach?',
  answer: 'We teach ages 3 and up. We have Mini Troopers (ages 3-5), Kids Taekwondo (ages 6+), Adult classes, and Family classes where parents and kids can train together.'
}, {
  question: 'How do I get started?',
  answer: 'Fill out the form on this page to claim your free one-week trial. We will contact you to confirm the best class time for your first visit.'
}];
export function TaekwondoNearMeFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-3400" />;
}